import { Box, Stack, useTheme } from "@mui/material";
import React from "react";
import { BorderedButton, GradientBorderBox } from "../../../../../Components";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";
import { productNavigatePath } from "../../../../../Utils/detailsNavigatePath";

export default function SmartGadgetCard({ pr }) {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Stack
            onClick={() => navigate(productNavigatePath(pr))}
      
      sx={{
        width: { xs: "120px", sm: "150px", md: "220px" },
        height: { xs: "120px", sm: "150px", md: "220px" },
        // bgcolor: "#f5f5f5",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        transition: "0.3s",
        position: "relative",
        "&:hover": {
          transform: "scale(1.02)",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "1.5rem",
          overflow: "hidden",
        }}
      >
        <img
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          src={
            pr?.image?.[0]?.file_name
              ? import.meta.env.VITE_URL + pr?.image?.[0]?.file_name
              : "/Media/nimobileIcon.png"
          }
          alt={pr?.image?.[0]?.alt}
          title={pr?.image?.[0]?.title}
        />
      </Box>
      <GradientBorderBox
        bgGrad="linear-gradient(
    135deg,
    #000000ff -30%,
    #313131 50%,
     #313131 130%
  )"
      />
      <BorderedButton
        sx={{
          position: "absolute",
          backgroundColor: theme.palette.primary.lowOpacity,
          // width: "max-content",
          color: "white",
          fontWeight: "bold",
          bottom: ".5rem",
          left: ".5rem",
          height: "40px",
          width: "40px",
          //   width:"" ,
          //   padding:".5rem" ,
          minWidth: "0",
          minHeight: "0",
        }}
        icon={false}
      >
        <ShoppingCartIcon
          sx={{ color: theme.palette.primary.main, fontSize: "1.3rem" }}
        />
      </BorderedButton>
    </Stack>
  );
}
